export type Invoice = {
  amount: number;
  createdAt: Date;
  invoiceNumber: string | null;
  receiptNumber: string | null;
  status: LegacyInvoiceFilterStatus | InvoiceFilterStatus | null;
  stripeCustomerId: string | null;
  stripeInvoiceId: string;
  url?: string;
};

export enum LegacyInvoiceFilterStatus {
  Paid = 'paid',
  Declined = 'void',
  Open = 'open',
}

export enum InvoiceFilterStatus {
  Paid = 'PAID',
  Unpaid = 'NOT PAID',
}

export type InvoiceSearchFilters = {
  status?: LegacyInvoiceFilterStatus | InvoiceFilterStatus;
  createdAfter?: Date;
  createdBefore?: Date;
  getSubscriptionType: boolean;
};
